// extracted by mini-css-extract-plugin
export default {"container":"YearCard_container__lRTuM","row":"YearCard_row__0YVi0","team":"YearCard_team__ZtdiU"};